export const useTime = () => {
    const getTimeSplit = (time: number) => {
        const getSeconds = `0${time % 60}`.slice(-2);
        const minutes = `${Math.floor(time / 60)}`;
        const getMinutes = `0${parseInt(minutes) % 60}`.slice(-2);
        const getHours = `0${Math.floor(time / 3600)}`.slice(-2);
        return { getSeconds, getMinutes, getHours };
    };

    return { getTimeSplit };
};
